import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class SignOffStepService extends StepBaseService {
  // @ts-ignore
  getExtensionKey = () => {
    return StepBusinessType.signOff;
  };
  // @ts-ignore
  addAdditionalFiles = (params: any) => this.sendSyncRequest("addAdditionalFiles", params);
}

export default new SignOffStepService();
